import { Box, Stack } from "@mui/material";
import { Card } from "../../ui/Card";
import { AddIcon } from "../../../common/iconsData";
import CustomDataTable from "../../ui/CustomDataTable";
import { usePickupAddress } from "../../../hooks/usePickupAddress";
import BreadCrumbs from "../../ui/BreadCrumbs";
import { useGetPickupAddress } from "../../../config/api";
import { StyledButton } from "../../ui/StyledButton";

const pickupAddressCol = [
  { field: "id", headerName: "ID", minWidth: 50 },
  {
    field: "address",
    headerName: "Address",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "city",
    headerName: "City",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "company_name",
    headerName: "Company Name",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "mobile_number",
    headerName: "Mobile Number",
    minWidth: 160,
    flex: 1,
  },
  {
    field: "nickname",
    headerName: "Nickname",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "person_name",
    headerName: "Person Name",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "postal_code",
    headerName: "Postal Code",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "state",
    headerName: "State",
    minWidth: 160,
    flex: 1,
  },
];

const ManagePickupAddress = () => {
  const { onOpen } = usePickupAddress();

  const { pickupAddress } = useGetPickupAddress();

  return (
    <>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <BreadCrumbs
          field="Settings"
          link="/settings"
          extra={[
            { text: "Pickup Address" },
            { text: "Manage Pickup Addresses" },
          ]}
        />
      </Box>
      <Card>
        <Stack direction={"row"} justifyContent={"flex-end"} marginBottom={4}>
          <StyledButton
            sx={{
              padding: "6px 20px",
              textTransform: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            variant="contained"
            onClick={onOpen}
          >
            <AddIcon
              sx={{
                fontSize: "14px",
                marginRight: "4px",
              }}
            />
            <p>Add Pickup Address</p>
          </StyledButton>
        </Stack>
        <CustomDataTable
          rows={pickupAddress ?? []}
          columns={pickupAddressCol}
          total={pickupAddress?.length ?? 0}
        />
      </Card>
    </>
  );
};

export default ManagePickupAddress;
